import { Component, OnInit } from '@angular/core';
import { faUniversalAccess } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent implements OnInit {

  get titleLabel(){ return "Accessibilità" }
  get titleIcon(){ return faUniversalAccess }

  constructor() { }

  ngOnInit(): void {
  }

}
